// extracted by mini-css-extract-plugin
export default {"inputRoot":"NumericInput_inputRoot__GaOEU","input":"NumericInput_input__kAd0H","button":"NumericInput_button__tUGu6"};